import { render } from "./ProductPriceSolarConfirmInfoCard.vue?vue&type=template&id=861675e8"
import script from "./ProductPriceSolarConfirmInfoCard.vue?vue&type=script&lang=js"
export * from "./ProductPriceSolarConfirmInfoCard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__